import { useState } from 'react';
import { Button } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { YouTubeVideoDialog } from './YouTubeVideoDialog';

interface YouTubeVideoButtonProps {
  videoId: string;
  videoTitle?: string;
  buttonText?: string;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

export const YouTubeVideoButton: React.FC<YouTubeVideoButtonProps> = ({
  videoId,
  videoTitle = 'Tutorial Video',
  buttonText = 'Watch Tutorial',
  variant = 'text',
  size = 'small',
  fullWidth = false,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        startIcon={<PlayArrowIcon />}
        onClick={handleOpen}
        aria-label={`Watch tutorial: ${videoTitle}`}
        sx={{
          textTransform: 'none',
          fontSize: size === 'small' ? '0.875rem' : undefined,
        }}
      >
        {buttonText}
      </Button>
      <YouTubeVideoDialog
        open={open}
        onClose={handleClose}
        videoId={videoId}
        title={videoTitle}
      />
    </>
  );
};
